import { proxy, ref } from 'valtio'
import { INITIAL_ZOOM } from '../components/map/types.ts'

// @ts-ignore
const _mapStyle = JSON.parse(localStorage.getItem('mapStyle'))
// @ts-ignore
const _savedMapState = JSON.parse(localStorage.getItem('mapState')) || {}

export const mapState = proxy({
    googleLoaded: false,
    map: null as google.maps.Map | null,
    bounds: null as google.maps.LatLngBounds | null,
    google: null as any,
    circles: [] as any[],
    mapStyle: (_mapStyle || 'default') as string,
    webSocketConnected: false,
    zoom: (_savedMapState.zoom || INITIAL_ZOOM) as number,
    historyZoom: INITIAL_ZOOM as number,
    myPosition: null as google.maps.LatLng | null,
    historyMapHeight: 0,
    mapContext: 'map' as 'map' | 'history',
    markerInfo: null as string | null,
    directionsTo: null as google.maps.LatLng | null,
    travelMode: ('' as any) as google.maps.TravelMode | null,
    locationEnabled: true,
    showMapStyle: false,
})

// --- Action functions ---

export function setMap(map: google.maps.Map | null) {
    mapState.map = map ? ref(map) as any : null
}

export function setBounds(bounds: google.maps.LatLngBounds | null) {
    mapState.bounds = bounds ? ref(bounds) as any : null
}

export function setGoogle(g: any) {
    mapState.googleLoaded = !!g
    mapState.google = g ? ref(g) : null
}

export function setMyPosition(pos: google.maps.LatLng) {
    mapState.myPosition = ref(pos) as any
}

export function setDirectionsTo(pos: google.maps.LatLng | null) {
    mapState.directionsTo = pos ? ref(pos) as any : null
}

export function setZoom(z: number) {
    const newZoom = z > 22 ? 22 : z
    mapState.zoom = newZoom
    // Save to localStorage for main map only (not history)
    if (mapState.mapContext === 'map') {
        const center = mapState.map?.getCenter()
        if (center) {
            localStorage.setItem('mapState', JSON.stringify({
                zoom: newZoom,
                center: { lat: center.lat(), lng: center.lng() }
            }))
        }
    }
}

export function resetMap() {
    mapState.map = null
    mapState.circles = []
    mapState.zoom = INITIAL_ZOOM
    mapState.historyZoom = INITIAL_ZOOM
    mapState.bounds = null
    mapState.historyMapHeight = 0
    mapState.mapContext = 'map'
    mapState.markerInfo = null
    mapState.travelMode = google.maps.TravelMode.WALKING
    mapState.directionsTo = null
    mapState.showMapStyle = false
}

export default mapState
